// ============================================================
// 顶部导航 Navbar（SPEC 2.1）
// ============================================================

import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAppStore } from "@/stores/appStore";

function Navbar() {
  const { isAuthenticated, user, logout } = useAppStore();
  const navigate = useNavigate();
  const location = useLocation();

  // 裸布局路由：显示端/字幕端/主播端/管理后台不渲染导航栏（SPEC 13.6）
  const bare =
    location.pathname.includes("/display") ||
    location.pathname.includes("/subtitle") ||
    location.pathname.includes("/anchor") ||
    location.pathname.startsWith("/admin");
  if (bare) return null;

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <nav className="sticky top-0 z-40 border-b border-ink-3 bg-ink-2/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-8">
          <Link to="/" className="group flex items-baseline gap-2">
            <span className="font-display text-2xl tracking-wide text-signal transition-colors hover:text-signal-deep">
              VoicePrompter
            </span>
            <span className="hidden rounded-full border border-signal/30 bg-signal/10 px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest text-signal sm:inline-block">
              v1.16
            </span>
          </Link>
          {isAuthenticated && (
            <div className="hidden gap-6 sm:flex">
              <Link
                to="/"
                className="text-sm text-paper-dim transition-colors hover:text-paper"
              >
                控制台
              </Link>
              <Link
                to="/settings"
                className="text-sm text-paper-dim transition-colors hover:text-paper"
              >
                设置
              </Link>
            </div>
          )}
        </div>

        <div className="flex items-center gap-4">
          {isAuthenticated ? (
            <>
              <span className="text-sm text-paper-dim">{user?.displayName}</span>
              <button
                onClick={handleLogout}
                className="rounded-md border border-ink-4 bg-ink-3 px-3 py-2 text-sm text-paper-dim transition-colors hover:border-danger/40 hover:text-danger"
              >
                退出
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="rounded-md px-3 py-2 text-sm text-paper-dim transition-colors hover:bg-ink-3 hover:text-paper"
              >
                登录
              </Link>
              <span className="rounded-md px-3 py-2 text-sm text-paper-faint">注册已关闭</span>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
